import {
  AbsoluteFill,
  spring,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import { GRAY, GOOGLE, ACCENT } from "../colors";

export const ConnectGBPAnimation: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const cardAppear = spring({ frame, fps, config: { damping: 14 } });
  const buttonClick = frame >= 40 && frame <= 48;
  const loadingPhase = frame > 48 && frame < 75;
  const connectedPhase = frame >= 75;
  const checkScale = spring({ frame: frame - 75, fps, config: { damping: 10, stiffness: 120 } });

  const spinAngle = loadingPhase ? (frame - 48) * 15 : 0;

  return (
    <AbsoluteFill
      style={{
        backgroundColor: GRAY[50],
        justifyContent: "center",
        alignItems: "center",
        padding: 36,
      }}
    >
      <div
        style={{
          transform: `scale(${cardAppear})`,
          opacity: cardAppear,
          backgroundColor: "white",
          borderRadius: 20,
          padding: "36px 40px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
          textAlign: "center",
          width: "100%",
          maxWidth: 420,
        }}
      >
        {/* Google icon */}
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: 16,
            background: connectedPhase ? ACCENT[500] : "white",
            border: connectedPhase ? "none" : `2px solid ${GRAY[200]}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 20px",
            fontSize: connectedPhase ? 28 : 26,
          }}
        >
          {connectedPhase ? (
            <span style={{ color: "white", transform: `scale(${checkScale})`, display: "inline-block" }}>✓</span>
          ) : loadingPhase ? (
            <span style={{ display: "inline-block", transform: `rotate(${spinAngle}deg)` }}>⟳</span>
          ) : (
            <span>G</span>
          )}
        </div>

        <div style={{ fontSize: 22, fontWeight: 700, color: GRAY[800], marginBottom: 8 }}>
          {connectedPhase ? "Connected!" : "Connect Google Business Profile"}
        </div>
        <div style={{ fontSize: 17, color: GRAY[400], marginBottom: 24, lineHeight: 1.4 }}>
          {connectedPhase
            ? "Your business is now linked to OneTapReply"
            : "Sign in to start monitoring reviews"}
        </div>

        {/* Button */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 10,
            padding: "14px 32px",
            borderRadius: 10,
            backgroundColor: connectedPhase ? ACCENT[500] : "white",
            color: connectedPhase ? "white" : GRAY[700],
            border: connectedPhase ? "none" : `1px solid ${GRAY[200]}`,
            fontSize: 18,
            fontWeight: 600,
            transform: buttonClick ? "scale(0.95)" : "scale(1)",
            boxShadow: connectedPhase ? "none" : "0 2px 8px rgba(0,0,0,0.08)",
          }}
        >
          {!connectedPhase && (
            <svg width="20" height="20" viewBox="0 0 20 20">
              <circle cx="10" cy="10" r="9" fill="none" stroke={GRAY[300]} strokeWidth="1" />
              <text x="10" y="14" textAnchor="middle" fontSize="11" fontWeight="bold" fill={GOOGLE.blue}>
                G
              </text>
            </svg>
          )}
          {connectedPhase ? "✓ Connected" : loadingPhase ? "Connecting..." : "Sign in with Google"}
        </div>
      </div>
    </AbsoluteFill>
  );
};
